import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import { WithNamespaces, withNamespaces } from "react-i18next";
import UserInfos from "src/components/UserInfos";

import * as User from "src/redux/user";

import { HeaderPage } from "src/components/HeaderPage";
const mapStateToProps = (state: AppState, props) => {
  return { user: state.user };
};
function mapDispatchToProps(dispatch) {
  return {
    updateUserProfil: (profil: User.Profil) =>
      dispatch(User.updateUserProfil(profil))
  };
}
type PropsWithMapState = ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  WithNamespaces;

class UserInfosContainerToConnect extends React.Component<PropsWithMapState> {
  render() {
    return (
      <div>
        <div className="mb-5">
          <HeaderPage title={this.props.t("user.infos.title")} />
        </div>
        <UserInfos
          updateUserProfil={this.props.updateUserProfil}
          profil={this.props.user.profil}
          organization={this.props.user.organization}
        />
      </div>
    );
  }
}

export const UserInfosContainer = withNamespaces()(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(UserInfosContainerToConnect)
);



// WEBPACK FOOTER //
// ./src/containers/UserInfosContainer.tsx